import { render, staticRenderFns } from "./SetUp.vue?vue&type=template&id=95e288c0&scoped=true&"
import script from "./SetUp.vue?vue&type=script&lang=js&"
export * from "./SetUp.vue?vue&type=script&lang=js&"
import style0 from "./SetUp.vue?vue&type=style&index=0&id=95e288c0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e288c0",
  null
  
)

export default component.exports